import { createGlobalStyle } from 'styled-components';

import InterRegular from './Inter-Regular.ttf';
import InterMedium from './Inter-Medium.ttf';
import InterSemiBold from './Inter-SemiBold.ttf';

export default createGlobalStyle`

  @font-face {
    font-family: 'Inter';
    src: local('Inter'), url(${InterRegular}) format('truetype');
    font-weight: 400;
    font-style: normal;
  }

@font-face {
  font-family: 'Inter';
  src: local('Inter'), url(${InterMedium}) format('truetype');
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'Inter';
  src: local('Inter'), url(${InterSemiBold}) format('truetype');
  font-weight: 600;
  font-style: normal;
}`;
